import React, {useState, useEffect} from 'react';
import { Col, Modal, ModalBody, ModalHeader,Button, Input, FormGroup, Label } from 'reactstrap';
import { useGetUserExecutionReport } from '../hooks/useGetUserExecutionReport';
import Toastr from "toastr";

const ShowUserExecutionsFilterModal: React.FC<{
    open: boolean;
    onClose: () => void
}> = ({ onClose, open }) => {
    const [startDate, setStartDate] = useState<string>("")
    const [endDate, setEndDate] = useState<string>("")
    const { data: userExecutionReport, refetch: fetchReport, isError: userExecutionReportError, error } = useGetUserExecutionReport(startDate, endDate);

    useEffect(() => {
        if(userExecutionReport?.report){
            const link = document.createElement('a');
            link.href = userExecutionReport?.report;
            link.setAttribute(
            'download',
            `User-execution-report.pdf`,
            );
        
            // Append to html link element page
            document.body.appendChild(link);
        
            // Start download
            link.click();

            if(link){
                // Clean up and remove the link
                link?.parentNode?.removeChild(link);
            }   
        }
    }, [userExecutionReport]);

useEffect(() => {
    if(!error){
        return;
    }

    if(error?.response?.status 
        && error?.response?.status === 400 
        && error?.response?.data?.msg){
        Toastr.error(error?.response?.data?.msg);
    }else{
        Toastr.error('Something went wrong !');
    }
}, [error])

  return (
    <>
      <Modal
        isOpen={open}
        toggle={onClose}
        backdrop={true}
        size='lg'
      >
        <ModalHeader>
          <h3>Select Date for User Executions report</h3>
          <i onClick={onClose} className="fas fa-lg fa-times" style={{ position: 'absolute', right: '20px', cursor: 'pointer' }} />
        </ModalHeader>
        <ModalBody>
          <Col>
            <FormGroup>
                <Label>Start Date</Label>
                <Input value={startDate} onChange={(e) => setStartDate(e.target.value)} type="date"></Input>
            </FormGroup>
            <FormGroup>
                <Label>End Date</Label>
                <Input value={endDate} onChange={(e) => setEndDate(e.target.value)} type="date"></Input>
            </FormGroup>
          </Col>
          <Col>
            <Button onClick={() => fetchReport()} color="warning">Download</Button>
          </Col>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ShowUserExecutionsFilterModal
